import { evolutiveCrossService } from "src/services/evolutiveCross";
import { withFulFilled, withPending, withRejected } from "../reducers/commons";

export const FETCH_EVOLUTIVE_CROSSED_QUESTIONS = "FETCH_EVOLUTIVE_CROSSED_QUESTIONS";

export const FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS = "FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS";

export const FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS = "FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS";

export const FETCH_SURVEY_CROSSED_QUESTIONS = "FETCH_SURVEY_CROSSED_QUESTIONS";

export const FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS = "FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS";

export const CREATE_EVOLUTIVE_CROSS_CONFIG = 'CREATE_EVOLUTIVE_CROSS_CONFIG';

export const FETCH_EVOLUTIVE_FILTERS_LIST = 'FETCH_EVOLUTIVE_FILTERS_LIST';

/**
 * Retorna uma promise que quando resolvida possui um conjunto de perguntas que contém cruzamentos simples com a pergunta
 * principal.
 * @param {number} clientId Id do cliente
 * @param {string} data Id's das perguntas e.g 1,2,3
 * @param {*} dispatch redux dispatch 
 */

export function fetchEvolutiveCrossedQuestions(
  clientId,
  data,
  dispatch
) {
  const resultPromise = evolutiveCrossService.fetchCrossedQuestions(
    clientId,
    data
  );

  dispatch({ type: withPending(FETCH_EVOLUTIVE_CROSSED_QUESTIONS) });

  resultPromise
    .then((data) => {
      dispatch({ type: withFulFilled(FETCH_EVOLUTIVE_CROSSED_QUESTIONS), payload: data });
    })
    .catch((error) => {
      dispatch({ type: withRejected(FETCH_EVOLUTIVE_CROSSED_QUESTIONS), payload: error });
    });
}

export function fetchEvolutiveStep2CrossedQuestions(
  clientId,
  data,
  dispatch
) {
  const resultPromise = evolutiveCrossService.fetchCrossedQuestions(
    clientId,
    data
  );

  dispatch({ type: withPending(FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS) });

  resultPromise
    .then((data) => {
      dispatch({ type: withFulFilled(FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS), payload: data });
    })
    .catch((error) => {
      dispatch({ type: withRejected(FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS), payload: error });
    });
}

// TODO: ADICIONAR COMENTÁRIO
export function fetchEvolutiveAlternativesAndCrossedQuestions(
  clientId,
  surveyIds,
  analyzeIds,
  withAlternatives,
  withCrossedQuestions,
  dispatch
) {
  const resultPromise = evolutiveCrossService.fetchAlternativesAndCrossedQuestions(
    clientId,
    surveyIds,
    analyzeIds,
    withAlternatives,
    withCrossedQuestions
  );

  dispatch({ type: withPending(FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS) });

  resultPromise
    .then((data) => {
      dispatch({ type: withFulFilled(FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS), payload: data });
    })
    .catch((error) => {
      dispatch({ type: withRejected(FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS), payload: error });
    });
}

// TODO: ADICIONAR COMENTÁRIO
export function fetchSurveysWithCrossedQuestions(
  clientId, 
  query = null, 
  initInterval = null, 
  endInterval = null,
  excludeSurveyId = null,
  dispatch,
) {
  const resultPromise = evolutiveCrossService.fetchSurveysWithCrossedQuestions(
    clientId,
    query,
    initInterval,
    endInterval,
    excludeSurveyId
  );

  dispatch({ type: withPending(FETCH_SURVEY_CROSSED_QUESTIONS) });

  resultPromise
    .then(({ data }) => {
      dispatch({ type: withFulFilled(FETCH_SURVEY_CROSSED_QUESTIONS), payload: data});
    })
    .catch((error) => {
      dispatch({ type: withRejected(FETCH_SURVEY_CROSSED_QUESTIONS), payload: error });
    });
}

/**
 * Dispacha a action de retorno das alternativas de uma lista de grupo de perguntas combinadas
 * @param {number} customerId Id do cliente 
 * @param {array} groupQuestions Grupo de perguntas combinadas
 * @param {*} dispatch redux dispatch 
 */
export function fetchAlternativesByGroupQuestions(customerId, groupQuestions, dispatch) {
  const result = evolutiveCrossService.getAlternativesByGroupQuestions(customerId, groupQuestions);

  dispatch({ type: withPending(FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS) });

  result.then((data) => {
    dispatch({ type: withFulFilled(FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS), payload: data })
  })
  .catch((error) => {
    dispatch({ type: withRejected(FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS), payload: error })
  });
}

/**
 * @param {*} configId Id da configuração do evolutivo de cruzamentos
 * @param {*} dispatch  redux dispatch
 */
export function fetchFiltersList(configId, dispatch) {
  const result = evolutiveCrossService.fetchListFilters(configId);

  dispatch({ type: withPending(FETCH_EVOLUTIVE_FILTERS_LIST) });

  result.then((data) => {
    dispatch({ type: withFulFilled(FETCH_EVOLUTIVE_FILTERS_LIST), payload: data })
  })
  .catch((error) => {
    dispatch({ type: withRejected(FETCH_EVOLUTIVE_FILTERS_LIST), payload: error })
  });
}